<template>
    <div id="app">        
        <!--Hier kann das FCM-Token angegezeigt werden -->
        <!--<div id='fcmtoken'>{{fcmtoken}}</div>-->
        <div v-bind:class="{'body':true, 'body-extraspace':($route.params.subid && !$route.params.postid)}">
            <!-- DEBUG <h3>FCM: {{ this.fcmsupported ? 'Läuft!' : 'NICHT UNTERSTÜTZT!' }}</h3> -->
            <!-- Routes get rendered here -->
            <router-view :key="this.$router.currentRoute.path"></router-view>
            <notifications group="information" position="bottom left"/>
        </div>
        <Header class="main_panel" :path="this.$router.currentRoute.path.toLowerCase()" :key="this.$router.currentRoute.path"></Header>
    </div>   
</template>
<script>
import MS_CONST from './msclasses/msconst.js'
import Header from './components/Header.vue'

export default {
    name: 'app',   
    components: {
        Header
    },
    data() {
        return {
            subscritptionChecked : false,
            fcmtoken: false,      // Firebase Token
            fcmsupported: true,   // Ist der Client Firebase-kmpatibel?
            backlink: "",         // Link zur vorherigen Seite (optional), wird durch Child-Komponenten gesetzt und vom Header ausgewertet            
            logintoken: "",       // Login-Token
            topicheaders: {},     // Kategorie-Überschriften, wird durch Topicview gesetzt und vom Header ausgewertet
            subtopics: {},        // Filter-Kategorien für die aktuellen Top-Kategorie
            topicsUpdated: false, // Neue Topicliste wurde aus dem Cache geholt
            messages: 0,          // Anzahl ungelesener Nachrichten
            webbook: {},          // Webbook-Texte
        };
    },
    mounted() {
        require('./assets/css/App.css')
        try { require('./assets/css/' + this.$mode + '/App.css') } catch (e) {}
    },
    created() {          
        var self = this;
        this.applySettings();
        this.loadWebbook();

        let path = this.$router.currentRoute.path.toLowerCase();
        if (!this.$ms.isLoggedIn() && !(path.includes("node") && path.includes("welcome")))
            this.checkLogin();            
    },
    updated() {
        this.$log.debug("updated");

        if (!this.$ms.isInProgress()) {
            this.$log.debug("updated: check login");
            this.checkLogin();       
        }
        if (this.$ms.isLoggedIn() && !this.subscritptionChecked) {
            this.$log.debug("updated: check push subscription");
            this.checkPushSubscription();       
        }

        // -ojb, 07.01.2020: Firebase wird nicht mehr verwendet
        // if (!this.fcmtoken && this.fcmsupport && this.fcmregistered) {
        //     this.getFcmToken();
        // }
        // if (this.fcmtoken && this.fcmsupport && this.fcmregistered) {
        //     this.messaging.onMessage(function(payload) {
        //         console.log("Message received. ", payload);
        //     });
        // }
    },
    methods: {
        applySettings() {            
            var self = this;
            this.$ms.loadCacheSettings(function(settings) {
                if (settings) {
                    // Settings anwenden
                    if (settings[MS_CONST.SETTING_FONTSIZE])
                        self.setFontSize(settings.fontSize);
                }                
            });
        },  
        loadWebbook() {
            var self = this;
            this.$ms.loadCacheWebbook(function(cache) {
                var cacheFound = (cache && self.$ms.hasElements(cache));
                if (cacheFound) {
                    self.$log.debug('webbook read from cache');
                    self.webbook = cache;
                } 
                if (!cacheFound && !self.$ms.isOnline()) {
                    self.$log.debug('webbook not found in cache and user not online');
                }
                if (self.$ms.isOnline()){
                    self.$ms.apiWebbook(self, function(err, data) {
                        if (!err)
                            {                            
                            if (!cacheFound) {
                                self.$log.debug('webbook read from web');    
                                if (self.$ms.hasElements(data))
                                    self.webbook = data;
                            }                            
                            // In den Cache speichern
                            self.$log.debug('webbook from web saved to cache');    
                            self.$ms.saveCacheWebbook(data);
                            }
                        else {
                            self.$log.warn('apiWebbook - msAxios meldet: ' + error);
                        }
                    });
                }
            });        
        },
        checkLogin() {
            var self = this;
            this.builtTopics = false;
            var path = this.$router.currentRoute.path.toLowerCase();
            if (path.includes("login") || path.includes("subscribe") || path.includes("settings") || path.includes("error"))
                return;

            this.$ms.loadCacheLogin(function(login) {                
                if (!login) {
                    self.$log.info('User not logged in.');

                    // Check: War der User schonmal auf der Seite?
                    // Falls nicht, zeige die Willkommensseite an 
                    self.$ms.isFirstVisit(function (response) {
                        if (response) {
                            self.$log.info('Forward to welcome page.');
                            self.$router.push({name: 'Webbook', params: { node: 'welcome' }});
                        }
                        else {
                            self.$log.info('Forward to login page.');
                            self.$router.push('/login');
                        }
                    });
                }
                else {
                    if (!login.token) {
                        self.$log.info('No user token: Forward to login page.');
                        self.$router.push('/login');
                        return;
                    }

                    self.logintoken = login.token;
                   // self.$log.debug('Login-Token is set to .', login.token);
                    self.messages = login.messages;
                    if (self.$ms.isOnline()) {                        
                        self.$log.debug('Check user logintoken.');
                        // Bei Fehlschlag leitet die API-Funktion direkt auf die Login-Seite
                        self.$ms.apiCheckToken(self, login.token, function(msg) {                            
                            self.messages = msg;
                            self.topicsUpdated = true;
                        });
                        self.checkedToken = true;                        
                    }
                }
            });
        },
        checkPushSubscription() {
            var self = this;            
            if (!('serviceWorker' in navigator && 'PushManager' in window)) {
                self.$log.debug('Skip checkPushSubscription: push messages not supported');
                self.subscritptionChecked = true; // Vorbesetzung, um Doppelaufruf der Funktion zu verhindern
                return false; 
                }
            navigator.serviceWorker.ready.then(function(registration) {
                self.subscritptionChecked = true; // Vorbesetzung, um Doppelaufruf der Funktion zu verhindern
                self.$ms.loadCacheSettings(function(settings) {
                    // Prüfen, ob Push-Subscription bereits erfolgt ist
                    if (settings && settings[MS_CONST.SETTING_SUBSCRIPTION]) {
                        self.$log.debug('Skip checkPushSubscription: Subscription ist bereits vorhanden.');
                        return;                    
                    } 
                    registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: self.$ms.urlB64ToUint8Array(self.$serverKey)
                    }).then(function(subscription) {
                        if (subscription === null) {
                            self.subscritptionChecked = false;
                            self.$log.warn('Skip checkPushSubscription: Service Worker does not get subscription.');
                            return;                    
                        }
                        self.$ms.apiSubscribePush(self, self.logintoken, subscription, function(){
                            /*
                            self.$notify({
                                group: 'information',
                                text: 'Sie wurden erfolgreich für Push-Nachrichten registriert.',
                                max: 1,
                                duration: 8000 //ms
                                });
                            */
                        });
                    });
                });    
            });
        },
        getFcmToken() {
            // -ojb, 07.01.2020: Firebase wird nicht mehr verwendet
            // Firebase Push-Registrierung
            var self = this;            
            self.fcmtoken = true; // Vorbesetzung, um Doppelaufruf der Funktion zu verhindern

            self.$ms.loadCacheSettings(function(settings) {
                // Prüfen, ob FCM-Token bereits registriert ist
                if (settings && settings[MS_CONST.SETTING_FCMTOKEN]) {
                    self.$log.debug('Skip getFcmToken: FCM-Token ist bereits vorhanden.');
                } else {
                    self.messaging.requestPermission()
                    .then(() => self.messaging.getToken())  // <-- HIER KOMMT 404, WENN SW-REGISTRIERUNG NOCH NICHT ABGESCHLOSSEN!
                    // .then((ftoken) => self.messaging.deleteToken(ftoken)) 
                    // .then(() => self.messaging.getToken()) 
                        .then((ftoken) => {
                            console.log("Receiver Token: ", ftoken) // Receiver Token to use in the notification
                            self.fcmtoken = ftoken;
                            var path = self.$router.currentRoute.path.toLowerCase();
                            self.$log.debug('path', path);
                            if (path.includes("ms-testmode")) {
                                self.$ms.apiSetFcmToken(self, ftoken, 1, function(){
                                    self.$notify({
                                        group: 'information',
                                        text: 'Für Push-TEST-Nachrichten registriert!',
                                        max: 1,
                                        duration: 8000 //ms
                                    });                             
                                });
                            } else {                
                                self.$ms.apiSetFcmToken(self, ftoken, 0, function(){
                                self.$notify({
                                    group: 'information',
                                    text: 'Sie wurden erfolgreich für Push-Nachrichten registriert.',
                                    max: 1,
                                    duration: 8000 //ms
                                    });
                                });
                            }
                        })
                        .catch(function(err) {
                            self.$log.error("Get FCM Token Error #2:", err);
                            self.fcmtoken = err;
                        })
                    .catch(function(err) {
                        self.$log.error("Get FCM Token Error #1:", err);
                        self.fcmtoken = err;
                    });
                }                
            });
        },                    
        setBacklink(backlink) {
            this.backlink = backlink;
        },
        setFontSize(size) {
            let element = document.getElementById('app');
            element.style.fontSize = size + 'px';
            this.$log.debug('font size is ' + size + 'px');      
        }
    }
}
</script>
<style/>